import React from 'react';
import { HelpCircle, ShieldCheck, Lock, Zap, ArrowRight, ChevronDown, Check } from 'lucide-react';
export function CheckoutSection() {
  const handleAddToCart = () => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'RUTA IT USA - Paquete Completo',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
  };
  return <section id="checkout" className="w-full" data-id="element-8">
      {/* FAQ */}
      <div className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-9">
        <div className="max-w-3xl mx-auto" data-id="element-10">
          <div className="text-center mb-12" data-id="element-11">
            <HelpCircle className="h-12 w-12 text-brandBlue mx-auto mb-4" data-id="element-12" />
            <h2 className="text-3xl font-bold text-navy" data-id="element-13">
              PREGUNTAS FRECUENTES
            </h2>
          </div>

          <div className="space-y-6" data-id="element-14">
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-15">
              <h4 className="text-lg font-bold text-navy mb-2 flex items-center" data-id="element-16">
                <span className="text-brandBlue mr-2" data-id="element-17">🔵</span> ¿Necesito saber
                matemáticas avanzadas?
              </h4>
              <p className="text-gray-700 ml-7" data-id="element-18">
                No. Para IT Support y UX solo necesitas lógica básica y
                disciplina.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-19">
              <h4 className="text-lg font-bold text-navy mb-2 flex items-center" data-id="element-20">
                <span className="text-brandRed mr-2" data-id="element-21">🔴</span> ¿Puedo hacerlo si
                tengo más de 40 años?
              </h4>
              <p className="text-gray-700 ml-7" data-id="element-22">
                Absolutamente. En IT se valora la madurez y la responsabilidad.
                Hay personas de 40, 50 y 60 años haciendo este cambio
                exitosamente.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-23">
              <h4 className="text-lg font-bold text-navy mb-2 flex items-center" data-id="element-24">
                <span className="text-brandGold mr-2" data-id="element-25">🟡</span> ¿Qué pasa si mi
                inglés es muy básico?
              </h4>
              <p className="text-gray-700 ml-7" data-id="element-26">
                El Capítulo 4 te da los scripts exactos para trabajar con inglés
                funcional. No necesitas ser bilingüe fluido.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-27">
              <h4 className="text-lg font-bold text-navy mb-2 flex items-center" data-id="element-28">
                <span className="text-green-500 mr-2" data-id="element-29">🟢</span> ¿Cuánto cuesta
                el curso de Google?
              </h4>
              <p className="text-gray-700 ml-7" data-id="element-30">
                Con nuestra guía te mostramos cómo solicitarlo gratis (Financial
                Aid) o pagarlo por menos de $150 en total.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-31">
              <h4 className="text-lg font-bold text-navy mb-2 flex items-center" data-id="element-32">
                <span className="text-brandBlue mr-2" data-id="element-33">🔵</span> ¿Cuándo recibo
                el producto?
              </h4>
              <p className="text-gray-700 ml-7" data-id="element-34">
                Inmediatamente después de tu compra. Recibirás un link de
                descarga directo en tu correo electrónico.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-35">
              <h4 className="text-lg font-bold text-navy mb-2 flex items-center" data-id="element-36">
                <span className="text-brandRed mr-2" data-id="element-37">🔴</span> ¿Necesito papeles
                para trabajar en IT?
              </h4>
              <p className="text-gray-700 ml-7" data-id="element-38">
                Para empleos corporativos, sí necesitas autorización de trabajo.
                Sin embargo, el conocimiento también te permite trabajar como
                freelance técnico en tu comunidad mientras regularizas tu
                situación.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Offer & Price */}
      <div className="bg-navy py-16 px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="max-w-4xl mx-auto" data-id="element-40">
          <div className="bg-white rounded-3xl overflow-hidden shadow-2xl" data-id="element-41">
            <div className="bg-brandRed text-white text-center py-4" data-id="element-42">
              <h2 className="text-2xl font-black uppercase tracking-wider" data-id="element-43">
                Oferta Especial de Lanzamiento
              </h2>
            </div>

            <div className="p-8 sm:p-12" data-id="element-44">
              <h3 className="text-2xl font-bold text-navy mb-6 text-center" data-id="element-45">
                Resumen de tu Inversión:
              </h3>

              <div className="space-y-4 mb-8" data-id="element-46">
                <div className="flex justify-between items-center py-3 border-b border-gray-100" data-id="element-47">
                  <span className="text-gray-700 font-medium flex items-center" data-id="element-48">
                    <span className="mr-2" data-id="element-49">📘</span> RUTA IT USA: Guía Maestra
                    Completa
                  </span>
                  <span className="text-gray-500" data-id="element-50">$27</span>
                </div>
                <div className="flex justify-between items-center py-3 border-b border-gray-100" data-id="element-51">
                  <span className="text-gray-700 font-medium flex items-center" data-id="element-52">
                    <span className="mr-2" data-id="element-53">🎁</span> Bono 1: Checklist 90 Días a
                    IT
                  </span>
                  <span className="text-gray-500" data-id="element-54">$17</span>
                </div>
                <div className="flex justify-between items-center py-3 border-b border-gray-100" data-id="element-55">
                  <span className="text-gray-700 font-medium flex items-center" data-id="element-56">
                    <span className="mr-2" data-id="element-57">🎁</span> Bono 2: Guion de Entrevista
                    Hispano a Prueba
                  </span>
                  <span className="text-gray-500" data-id="element-58">$18</span>
                </div>
                <div className="flex justify-between items-center py-3 border-b border-gray-100" data-id="element-59">
                  <span className="text-gray-700 font-medium flex items-center" data-id="element-60">
                    <span className="mr-2" data-id="element-61">🎁</span> Bono 3: Plantilla Resume
                    ATS 1 Página
                  </span>
                  <span className="text-gray-500" data-id="element-62">$17</span>
                </div>
                <div className="flex justify-between items-center py-4 bg-gray-50 px-4 rounded-lg" data-id="element-63">
                  <span className="text-navy font-bold" data-id="element-64">💎 VALOR TOTAL</span>
                  <span className="text-navy font-bold line-through" data-id="element-65">$79</span>
                </div>
              </div>

              <div className="text-center mb-8" data-id="element-66">
                <p className="text-gray-500 font-medium mb-2 uppercase tracking-wide" data-id="element-67">
                  Tu Precio Hoy
                </p>
                <div className="flex items-center justify-center" data-id="element-68">
                  <span className="text-6xl font-black text-brandRed" data-id="element-69">
                    $6,39
                  </span>
                </div>
                <p className="text-sm text-brandRed font-bold mt-2" data-id="element-70">
                  Oferta temporal.
                </p>
              </div>

              <a href="https://www.tumundoequilibrado.com/cart/51218853200167:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="w-full bg-brandRed hover:bg-brandRed-600 text-white font-black text-xl sm:text-2xl py-5 px-8 rounded-xl transition-all transform hover:scale-[1.02] shadow-[0_8px_20px_0_rgba(229,62,62,0.4)] flex flex-col items-center justify-center" data-id="element-71">
                <span data-id="element-72">SÍ, QUIERO TODO EL PAQUETE POR SOLO $6,39</span>
              </a>

              <div className="flex flex-wrap justify-center gap-6 mt-6 text-sm text-gray-500 font-medium" data-id="element-73">
                <span className="flex items-center" data-id="element-74">
                  <Lock className="w-4 h-4 mr-1" data-id="element-75" /> Pago 100% seguro
                </span>
                <span className="flex items-center" data-id="element-76">
                  <Zap className="w-4 h-4 mr-1" data-id="element-77" /> Descarga inmediata
                </span>
                <span className="flex items-center" data-id="element-78">
                  <ShieldCheck className="w-4 h-4 mr-1" data-id="element-79" /> Garantía 30 días
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Guarantee */}
      <div className="bg-gray-50 py-16 px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="max-w-3xl mx-auto bg-white p-8 sm:p-10 rounded-2xl border-2 border-brandGold border-dashed text-center" data-id="element-81">
          <ShieldCheck className="h-16 w-16 text-brandGold mx-auto mb-6" data-id="element-82" />
          <h2 className="text-2xl sm:text-3xl font-black text-navy mb-4" data-id="element-83">
            Garantía de 30 Días Sin Preguntas
          </h2>
          <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-84">
            Si en los primeros 30 días sientes que esta guía no te dio el mapa
            que necesitabas, te devolvemos el 100% de tu dinero. Sin preguntas.
            Sin formularios complicados. Solo escríbenos y listo.
          </p>
          <p className="text-xl font-bold text-navy" data-id="element-85">
            Tu riesgo es cero. El nuestro es total.
          </p>
        </div>
      </div>

      {/* Urgency & Post-CTA */}
      <div className="bg-navy text-white py-16 px-4 sm:px-6 lg:px-8 text-center border-t border-navy-700" data-id="element-86">
        <div className="max-w-3xl mx-auto" data-id="element-87">
          <h2 className="text-3xl font-bold mb-8" data-id="element-88">
            Todo esto por $27. pero si compras hoy. Tu pagarás solo $6,39 por
            todo esto
          </h2>
          <p className="text-xl text-brandGold font-bold mb-10" data-id="element-89">
            No $79. No $27. solo $6,39
          </p>

          <div className="bg-navy-700 p-8 rounded-xl mb-10 text-left" data-id="element-90">
            <p className="text-lg text-gray-300 mb-4" data-id="element-91">
              Menos de lo que gastas en una salida a comer.
            </p>
            <p className="text-lg text-gray-300 mb-4" data-id="element-92">
              Pero a diferencia de esa cena, esto no desaparece en 2 horas.
            </p>
            <p className="text-lg text-gray-300 mb-8" data-id="element-93">
              Esto cambia el rumbo de los próximos 5 años de tu vida.
            </p>

            <p className="text-xl font-bold text-white mb-4" data-id="element-94">
              Tienes dos opciones hoy:
            </p>
            <ul className="space-y-4 mb-8" data-id="element-95">
              <li className="flex items-start" data-id="element-96">
                <span className="text-brandRed font-bold mr-3 mt-1" data-id="element-97">
                  Opción A:
                </span>
                <span className="text-gray-300" data-id="element-98">
                  Cerrar esta página, volver al trabajo de mañana, y seguir
                  esperando que algo cambie solo.
                </span>
              </li>
              <li className="flex items-start" data-id="element-99">
                <span className="text-green-400 font-bold mr-3 mt-1" data-id="element-100">
                  Opción B:
                </span>
                <span className="text-white font-medium" data-id="element-101">
                  Invertir $6,39 hoy y tener en tus manos el mapa completo, las
                  herramientas listas, y el plan para ejecutar desde mañana.
                </span>
              </li>
            </ul>

            <p className="text-xl font-bold text-white text-center" data-id="element-102">
              La pregunta no es si puedes permitirte esta guía.
              <br data-id="element-103" />
              <span className="text-brandRed" data-id="element-104">
                La pregunta es: ¿puedes permitirte seguir sin ella?
              </span>
            </p>
          </div>

          <a id="comprar" href="https://www.tumundoequilibrado.com/cart/51218853200167:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="bg-brandRed hover:bg-brandRed-600 text-white font-bold text-xl py-4 px-10 rounded-lg transition-colors shadow-lg inline-flex items-center w-full sm:w-auto justify-center mb-6" data-id="element-105">
            SÍ, QUIERO TODO EL PAQUETE POR SOLO $6,39
            <ArrowRight className="ml-2 h-6 w-6" data-id="element-106" />
          </a>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-400 font-medium" data-id="element-107">
            <span className="flex items-center" data-id="element-108">
              <Lock className="w-4 h-4 mr-1" data-id="element-109" /> Pago 100% seguro
            </span>
            <span className="flex items-center" data-id="element-110">
              <Zap className="w-4 h-4 mr-1" data-id="element-111" /> Descarga inmediata
            </span>
            <span className="flex items-center" data-id="element-112">
              <ShieldCheck className="w-4 h-4 mr-1" data-id="element-113" /> Garantía 30 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}